import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/custom.scss'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(BootstrapVue)
Vue.use(VueReCaptcha, { siteKey: '6Leha6sZAAAAAE0tPnZX3WaUCNZkooHlr5hKl3Z7' })

axios.defaults.baseURL = process.env.VUE_APP_URL_SERVER;
axios.defaults.headers.get['Content-Type'] = "application/json";
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.common['Cache-Control'] = 'no-cache'

axios.interceptors.request.use(function(config) {

  config.headers.Auth = process.env.VUE_APP_TKN;

  return config;
}, function(err) {
  return Promise.reject(err);
});


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
